import { appConfigContext } from 'nexchange-service/appServiceConfig'

import { TPriceRespApiDto } from '../api'


const getCustomDefaultAmount = (minAmount: number): number => {
    const {
        DEFAULT_COIN_MIN_AMOUNT_CUSTOMS
    } = appConfigContext.getAppConfig()
    
    for (let i = 0; i < DEFAULT_COIN_MIN_AMOUNT_CUSTOMS.length; i++) {
        if (DEFAULT_COIN_MIN_AMOUNT_CUSTOMS[i] >= minAmount) {
            return DEFAULT_COIN_MIN_AMOUNT_CUSTOMS[i];
        }
    }

    return minAmount
}

const getDefaultAmount = (minAmount: number): number => {
    const {
        DEFAULT_COIN_MIN_AMOUNT_MULTIPLIER,
        DEFAULT_COIN_MIN_AMOUNT_CUSTOMS
    } = appConfigContext.getAppConfig()
    if (DEFAULT_COIN_MIN_AMOUNT_CUSTOMS) return getCustomDefaultAmount(minAmount)

    return Number(minAmount) * DEFAULT_COIN_MIN_AMOUNT_MULTIPLIER
}

const getValidatedAmountsDto = (
    coinPairServerDto: TPriceRespApiDto,
): { amount_quote: number; amount_base: number; wasAmountValid: boolean } => {
    const {
        DEFAULT_COIN_MIN_AMOUNT_CUSTOMS
    } = appConfigContext.getAppConfig()

    const {
        min_amount_quote,
        min_amount_base,
        max_amount_quote,
        max_amount_base,
        amount_quote,
        amount_base,
    } = coinPairServerDto

    const isAmountValid =
        amount_quote > min_amount_quote &&
        amount_quote < max_amount_quote &&
        amount_base > min_amount_base &&
        amount_base < max_amount_base &&
        !DEFAULT_COIN_MIN_AMOUNT_CUSTOMS

    const amountsDto = isAmountValid
        ? { amount_quote, amount_base }
        : DEFAULT_COIN_MIN_AMOUNT_CUSTOMS 
        ? {
            amount_quote: getDefaultAmount(Number(min_amount_quote)),
            amount_base: null
        }
        : {
            amount_quote: getDefaultAmount(Number(min_amount_quote)),
            amount_base: getDefaultAmount(Number(min_amount_base)),
        }

    return {
        ...amountsDto,
        wasAmountValid: isAmountValid,
    }
}

export { getValidatedAmountsDto, getDefaultAmount }
